import React from 'react'

const Jva_ncr = () => {
    return (
        <div className='container'>
            <div>
   
   <h3 >JAVA program to find the value of nCr(Combination) using method</h3>
   <p>This JAVA program is to find the value of nCr(Combination) using method.</p>
   <p>For example, value of nCr<strong>(Combination) using method</strong>&nbsp;of <strong>5C3&nbsp;&nbsp;</strong>will
      be <strong>nCr= 10</strong>.</p>
   <h4>Logic</h4>
   <p>To find combination we use the concept of finding factorial of a number and use the standard formula for
      <strong>nCr=n!/r!*(n-r)! </strong>.</p>
   <h4>Dry Run of the Program</h4>
   <p>Take input n=5 and r=3</p>
   <p>ncr=fact(n)/fact(r)*fact(n-r) i.e.&nbsp;npr=fact(5)/fact(3)*fact(5-3)&nbsp; i.e.&nbsp;npr=fact(5)/fact(3)*fact(2)
   </p>
   <p>Now function fact() is called.</p>
   <p>We now calculate fact(5),fact(3) and fact(2)</p>
   <p>int fact(int n)</p>
   <p>n=5</p>
   <p>Initialize f=1;</p>
   <p>1st iteration for(i=1;i&lt;=n;i++)&nbsp; i.e.&nbsp;for(i=1;1&lt;=5;i++)</p>
   <p>f=f*i; i.e. f=1*1&nbsp; i.e. <strong>f=1</strong></p>
   <p>2nd iteration for(i=2;i&lt;=n;i++)&nbsp; i.e.&nbsp;for(i=2;2&lt;=5;i++)</p>
   <p>f=f*i; i.e. f=1*2&nbsp; i.e. <strong>f=2</strong></p>
   <p>3rd iteration for(i=3;i&lt;=n;i++)&nbsp; i.e.&nbsp;for(i=3;3&lt;=5;i++)</p>
   <p>f=f*i; i.e. f=2*3&nbsp; i.e. <strong>f=6</strong></p>
   <p>4th iteration for(i=4;i&lt;=n;i++)&nbsp; i.e.&nbsp;for(i=4;4&lt;=5;i++)</p>
   <p>f=f*i; i.e. f=6*4&nbsp; i.e. <strong>f=24</strong></p>
   <p>5th iteration for(i=5;i&lt;=n;i++)&nbsp; i.e.&nbsp;for(i=5;5&lt;=5;i++)</p>
   <p>f=f*i; i.e. f=24*5&nbsp; i.e. <strong>f=120</strong></p>
   <p>Now we break out of the for loop as i will now be greater than n(5).</p>
   <p>In a&nbsp;similar way, we calculate fact(3) &amp; fact(2) for which answer will be 2</p>
   <p>Hence 5c3 = 120/6*2 = <strong>10</strong>.</p>
   <p>As practice you can run the same program with the
        different ways of using methods.</p>
   <h4>Program</h4>
   <p></p>
   <div id="crayon-60be4df88b69c773981601"
      class="plainntax keywordsheme-classic crayon-font-monaco keywordss-pc print-yes notranslate"
      data-settings=" minimize scroll-always">
      <div class="keywordsoolbar" data-settings=" mouseover overlay hide delay"><span class="keywordsitle">java program
            to find the value of nCr(Combination) using method</span>
         <div class="keywordsools">
          
            <div class="crayon-button crayon-popup-button" title="Open Code In New Window">
               <div class="crayon-button-icon">
               </div>
            </div><span class="crayon-language">Java</span>
         </div>
      </div>
      
      <div class="containers" >
         
                     
                     
                  
                  <td class="crayon-code">
                     <div class="crayon-pre">
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-1"><span
                              class="library">import</span><span class="crayon-h"> </span><span
                              class="plain">java</span><span class="plain">.</span><span
                              class="plain">util</span><span class="plain">.</span><span
                              class="keywords">*</span><span class="plain">;</span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-2">&nbsp;</div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-3"><span
                              class="keywords">class</span><span class="crayon-h"> </span><span
                              class="library">mr5</span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-4"><span
                              class="plain">&#123;</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-5"><span class="crayon-h">
                           </span><span class="crayon-m">public</span><span class="crayon-h"> </span><span
                              class="crayon-m">static</span><span class="crayon-h"> </span><span
                              class="keywords">void</span><span class="crayon-h"> </span><span
                              class="library">main</span><span class="plain">(</span><span
                              class="keywords">String</span><span class="crayon-h"> </span><span
                              class="plain">args</span><span class="plain">[</span><span
                              class="plain">]</span><span class="plain">)</span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-6"><span
                              class="crayon-h"> </span><span class="plain">&#123;</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-7"><span class="crayon-h">
                           </span><span class="library">Scanner </span><span class="plain">sc</span><span
                              class="crayon-h"> </span><span class="keywords">=</span><span class="crayon-h">
                           </span><span class="library">new</span><span class="crayon-h"> </span><span
                              class="library">Scanner</span><span class="plain">(</span><span
                              class="plain">System</span><span class="plain">.</span><span
                              class="crayon-st">in</span><span class="plain">)</span><span
                              class="plain">;</span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-8"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="plain">System</span><span
                              class="plain">.</span><span class="plain">out</span><span
                              class="plain">.</span><span class="library">println</span><span
                              class="plain">(</span><span class="crayon-s">"Enter a number N"</span><span
                              class="plain">)</span><span class="plain">;</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-9"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="keywords">int</span><span
                              class="crayon-h"> </span><span class="plain">n</span><span
                              class="keywords">=</span><span class="plain">sc</span><span
                              class="plain">.</span><span class="library">nextInt</span><span
                              class="plain">(</span><span class="plain">)</span><span class="plain">;</span>
                        </div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-10"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="plain">System</span><span
                              class="plain">.</span><span class="plain">out</span><span
                              class="plain">.</span><span class="library">println</span><span
                              class="plain">(</span><span class="crayon-s">"Enter a number R"</span><span
                              class="plain">)</span><span class="plain">;</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-11"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="keywords">int</span><span
                              class="crayon-h"> </span><span class="plain">r</span><span
                              class="keywords">=</span><span class="plain">sc</span><span
                              class="plain">.</span><span class="library">nextInt</span><span
                              class="plain">(</span><span class="plain">)</span><span class="plain">;</span>
                        </div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-12"><span
                              class="crayon-h">&nbsp;&nbsp; </span><span class="keywords">int</span><span
                              class="crayon-h"> </span><span class="plain">ncr</span><span
                              class="keywords">=</span><span class="library">fact</span><span
                              class="plain">(</span><span class="plain">n</span><span
                              class="plain">)</span><span class="keywords">/</span><span
                              class="plain">(</span><span class="library">fact</span><span
                              class="plain">(</span><span class="plain">r</span><span
                              class="plain">)</span><span class="keywords">*</span><span
                              class="library">fact</span><span class="plain">(</span><span
                              class="plain">n</span><span class="keywords">-</span><span
                              class="plain">r</span><span class="plain">)</span><span
                              class="plain">)</span><span class="plain">;</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-13">&nbsp;</div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-14"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="plain">System</span><span
                              class="plain">.</span><span class="plain">out</span><span
                              class="plain">.</span><span class="library">println</span><span
                              class="plain">(</span><span class="crayon-s">"Value of "</span><span
                              class="keywords">+</span><span class="plain">n</span><span
                              class="keywords">+</span><span class="crayon-s">"C"</span><span
                              class="keywords">+</span><span class="plain">r</span><span
                              class="keywords">+</span><span class="crayon-s">" = "</span><span
                              class="keywords">+</span><span class="plain">ncr</span><span
                              class="plain">)</span><span class="plain">;</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-15"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="plain">&#125;</span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-16"><span
                              class="crayon-h"> </span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-17"><span class="crayon-h">
                           </span><span class="crayon-m">static</span><span class="crayon-h"> </span><span
                              class="keywords">int</span><span class="crayon-h"> </span><span
                              class="library">fact</span><span class="plain">(</span><span
                              class="keywords">int</span><span class="crayon-h"> </span><span
                              class="plain">n</span><span class="plain">)</span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-18"><span
                              class="crayon-h"> </span><span class="plain">&#123;</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-19"><span class="crayon-h">
                           </span><span class="keywords">int</span><span class="crayon-h"> </span><span
                              class="plain">i</span><span class="plain">,</span><span
                              class="plain">f</span><span class="keywords">=</span><span
                              class="plain">1</span><span class="plain">;</span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-20"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="crayon-st">for</span><span
                              class="plain">(</span><span class="plain">i</span><span
                              class="keywords">=</span><span class="plain">1</span><span
                              class="plain">;</span><span class="plain">i</span><span
                              class="keywords">&lt;=</span><span class="plain">n</span><span
                              class="plain">;</span><span class="plain">i</span><span
                              class="keywords">++</span><span class="plain">)</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-21"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="plain">&#123;</span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-22"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span
                              class="plain">f</span><span class="keywords">=</span><span
                              class="plain">f</span><span class="keywords">*</span><span
                              class="plain">i</span><span class="plain">;</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-23"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="plain">&#125;</span><span
                              class="crayon-h"> </span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-24"><span
                              class="crayon-h">&nbsp;&nbsp;&nbsp;&nbsp; </span><span
                              class="crayon-st">return</span><span class="crayon-h"> </span><span
                              class="plain">f</span><span class="plain">;</span></div>
                        <div class="crayon-line" id="crayon-60be4df88b69c773981601-25"><span class="crayon-h">
                           </span><span class="plain">&#125;</span></div>
                        <div class="crayon-line crayon-striped-line" id="crayon-60be4df88b69c773981601-26"><span
                              class="plain">&#125;</span></div>
                     </div>
                  </td>
            
      </div>
   </div>

   <p></p>
  


</div>

        </div>
    )
}

export default Jva_ncr
